import React, { useEffect } from "react";
import { useSearchParams } from "react-router";
import { getSearchParamString } from "../../config";
import { getWithExpiry, setWithExpiry } from "../../utilities/localStorage";
import { defaultPlanSelection, promoKey } from "../../config/constants";
import { getString } from "../../utilities";

export default function PromoRedemptionStatus({ selectedSubsPlan, isFamily, promo, setPromo, setPlan }) {
  const [params] = useSearchParams();

  useEffect(() => {
    const couponCode = params.get(getSearchParamString("coupon"));
    if (couponCode && couponCode.toLowerCase() === promoKey) {
      setWithExpiry(promoKey, 1, 30 * 24 * 1000 * 3600, true);
    }
    if (getWithExpiry(promoKey)) {
      setPromo(promoKey);
    }
  }, [selectedSubsPlan]);

  if (!isFamily || !promo) {
    return null;
  }
  if (selectedSubsPlan === defaultPlanSelection) {
    return (
      <div className="promo-message-container valid-promo">{getString("promo.applied.validPlan", { html: true })}</div>
    );
  }
  return (
    <div className="promo-message-container invalid-promo">
      <span className="promo-warning">{getString("promo.applied.invalidPlan")}</span>
      <span className="switch-plan" role="button" onClick={() => setPlan(defaultPlanSelection)}>
        {getString("promo.applied.switch")}
      </span>
    </div>
  );
}
